import { makeActionCreator } from '../../config/store/utils'
import {
  getWithContract,
  getWithoutContract,
  getDetailWithContract,
  getDetailWithoutContract
} from '../../services/charts'

export const CONTRACTORDERS = 'CONTRACTORDERS'
export const CONTRACTORDERS_ERROR = 'CONTRACTORDERS_ERROR'
export const CONTRACTORDERS_SUCCESS = 'CONTRACTORDERS_SUCCESS'
export const onContractOrders = makeActionCreator(CONTRACTORDERS)
export const onContractOrdersError = makeActionCreator(CONTRACTORDERS_ERROR, 'payload')
export const onContractOrdersSuccess = makeActionCreator(CONTRACTORDERS_SUCCESS, 'payload')
export const onContractOrdersThunk = (idEntity, year) => async dispatch => {
  dispatch(onContractOrders())

  try {
    const [resNoContract, resWithContract] = await Promise.all([
      getWithoutContract({ idEntity, year }),
      getWithContract({ idEntity, year })
    ])

    if (resNoContract.data.success !== 'OK') {
      return dispatch(onContractOrdersError(resNoContract.data.errores))
    }

    const NoContract = resNoContract.data.payload.find(item => item.year === year)
    const WithContract = resWithContract.data.payload.find(item => item.year === year)
    const totalValue = NoContract.value + WithContract.value
    const NoPercentage = Math.round((NoContract.value * 100) / totalValue)
    const WithPercentage = Math.round((WithContract.value * 100) / totalValue)
    const payload = {
      NoContract: { ...NoContract, percentage: NoPercentage },
      WithContract: { ...WithContract, percentage: WithPercentage }
    }

    return dispatch(onContractOrdersSuccess(payload))
  } catch (error) {
    return dispatch(onContractOrdersError(error))
  }
}

export const CONTRACTSDETAILS = 'CONTRACTSDETAILS'
export const CONTRACTSDETAILS_ERROR = 'CONTRACTSDETAILS_ERROR'
export const CONTRACTSDETAILS_SUCCESS = 'CONTRACTSDETAILS_SUCCESS'
export const onContractDetails = makeActionCreator(CONTRACTSDETAILS)
export const onContractDetailsError = makeActionCreator(CONTRACTSDETAILS_ERROR, 'payload')
export const onContractDetailsSuccess = makeActionCreator(CONTRACTSDETAILS_SUCCESS, 'payload')
export const onContractDetailsThunk = (idEntity, year) => async dispatch => {
  dispatch(onContractDetails())

  try {
    const response = await getDetailWithContract({ idEntity, year })

    if (response.data.success !== 'OK') {
      return dispatch(onContractDetailsError(response.data.errores))
    }

    const { data: tableStructure } = response.data.payload.find(item => item.year === year)
    const csvStructure = [
      [
        'Código ficha de contrato',
        'Número de orden de compra',
        'Monto orden de compra (UTM)',
        'Estado de la orden de compra'
      ],
      ...tableStructure.map(item => [
        item.contractCode === '0' ? 'No existe' : item.contractCode,
        item.orderCode,
        item.amountUTM,
        item.status
      ])
    ]

    return dispatch(onContractDetailsSuccess({ csvStructure, tableStructure }))
  } catch (error) {
    return dispatch(onContractDetailsError({ error }))
  }
}
export const onNoContractDetailsThunk = (idEntity, year) => async dispatch => {
  dispatch(onContractDetails())

  try {
    const response = await getDetailWithoutContract({ idEntity, year })

    if (response.data.success !== 'OK') {
      return dispatch(onContractDetailsError(response.data.errores))
    }

    const { data: tableStructure } = response.data.payload.find(item => item.year === year)
    const csvStructure = [
      [
        'Código ficha de contrato',
        'Número de orden de compra',
        'Monto orden de compra (UTM)',
        'Estado de la orden de compra'
      ],
      ...tableStructure.map(item => [
        item.contractCode === '0' ? 'No existe' : item.contractCode,
        item.orderCode,
        item.amountUTM,
        item.status
      ])
    ]

    return dispatch(onContractDetailsSuccess({ csvStructure, tableStructure }))
  } catch (error) {
    return dispatch(onContractDetailsError({ error }))
  }
}
